import React, { useRef, useEffect, useState, memo } from "react";
import useScript from "./useSecript";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const Player = memo(({ id, setWatch }) => {
  // const [progress, setProgress] = useState(10);

  const token = useSelector((state) => state.Auth.userInfo?.token);
  let interval;
  const { id: idCourse, idVed, sectionId } = useParams();

  const playerRef = useRef(null);
  const resultTextRef = useRef(null);
  //const [CONTENT_ID, setCONTENT_ID] = useState("")
  // useEffect(() => {
  //     if (id)
  //         setCONTENT_ID(id)
  // }, [id])

  const loadPlayer = () => {
    const myPlayer = window["dacast"](id, playerRef.current);
    myPlayer.onComplete(function () {
      if (token)
        setWatch({
          session_id: idVed,
          section_id: sectionId,
          course_id: idCourse,
        });
      // resultTextRef.current.innerHTML = "Hope you enjoyed!<br/>You watched all " + "duration" + " secs of the video!";
    });

    let progress = 0;
    myPlayer.onPlay(function () {
      interval = setInterval(() => {
        let wanted = (myPlayer.currentTime() * 100) / myPlayer.duration();
        if (token)
          if (wanted >= progress + 10) {
            progress += 10;
            setWatch({
              session_id: idVed,
              progress: progress,
            });
          }
        clearInterval(this);
      }, 1000);
    });
    myPlayer.onPause(function () {
      if (interval) clearInterval(interval);
    });
  };
  useScript({
    contentId: id,
    onLoad: loadPlayer,
  });
  // useEffect(() => {
  //   const options = {
  //     width: 350,
  //     height: 200
  //   };

  //   setTimeout(() => {
  //     const myPlayer = window["dacast"](CONTENT_ID, playerRef.current, options);
  //     myPlayer.onPlay(function () {
  //       var timeLeft = myPlayer.duration() - myPlayer.currentTime();
  //       setInterval(() => {
  //         let wanted = myPlayer.duration() * 90 / 100;
  //         if (myPlayer.currentTime() >= wanted) {
  //
  //         }
  //         resultTextRef.current.innerHTML = myPlayer.currentTime();
  //       }, 1000);
  //       myPlayer.onComplete(function () {
  //         resultTextRef.current.innerHTML = "Hope you enjoyed!<br/>You watched all " + "duration" + " secs of the video!";
  //       });
  //       myPlayer.onPause(function () {
  //         var alreadyWatched = myPlayer.currentTime();
  //         resultTextRef.current.innerHTML = "Taking a break?<br/>You already watched " + alreadyWatched + " secs";
  //       });
  //     });
  //   }, 5000);

  //     // // rest of the code for setting up the player

  //   // return () => {
  //   //   // myPlayer.destroy();
  //   // };
  // }, []);

  return (
    <div>
      <div ref={playerRef}></div>
      <div ref={resultTextRef}></div>
    </div>
  );
});

export default Player;
